import {
    setInvalid as shippingSetInvalid,
    unsetInvalid as shippingUnsetInvalid
} from '../../_flux/actions/shipping_address_actions';
import {
    setInvalid as billingSetInvalid,
    unsetInvalid as billingUnsetInvalid
} from '../../_flux/actions/billing_address_actions';
import EmailValidator from '../../validator/email_validator';
import PostcodeValidator from '../../validator/postcode_validator';

export function validateShippingAddress(address) {
    const {firstName, lastName, email, telephone, postcode} = address;

    validateFirstName(firstName) ? shippingSetInvalid('firstName') : shippingUnsetInvalid('firstName');
    validateLastName(lastName) ?  shippingSetInvalid('lastName') : shippingUnsetInvalid('lastName');
    validateTelephone(telephone) ?  shippingSetInvalid('telephone') : shippingUnsetInvalid('telephone');
    validateEmail(email) ?  shippingSetInvalid('email') : shippingUnsetInvalid('email');
    validatePostcode(postcode) ?  shippingSetInvalid('postcode') : shippingUnsetInvalid('postcode');
}

export function validateBillingAddress(address) {
    const {firstName, lastName, email, telephone} = address;

    validateFirstName(firstName) ? billingSetInvalid('firstName') : billingUnsetInvalid('firstName');
    validateLastName(lastName) ? billingSetInvalid('lastName') : billingUnsetInvalid('lastName');
    validateEmail(email) ? billingSetInvalid('email') : billingUnsetInvalid('email');
    validateTelephone(telephone) ? billingSetInvalid('telephone') : billingUnsetInvalid('telephone');
}

function validateFirstName(firstName) {
    return null === firstName || firstName.trim().length < 3;
}

function validateLastName(lastName) {
    return null === lastName || lastName.trim().length < 3;
}

function validateTelephone(telephone) {
    return null === telephone || telephone.trim().length < 3;
}

function validateEmail(email) {
    return !EmailValidator.validate(email);
}

function validatePostcode(postcode) {
    return !PostcodeValidator.validate(postcode);
}

